import { NBSP, roundNumber } from "web_myplann/Shared/Utils/numberFormatters";

export const signedPercentageValueFormatter = new Intl.NumberFormat("cs-CZ", {
	signDisplay: "exceptZero",
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const DEFAULT_PERCENTAGE_FRACTION_DIGITS = 2;

export const formatPercentage = (
	value: number | null | undefined,
	maxFractionDigits = DEFAULT_PERCENTAGE_FRACTION_DIGITS,
) =>
	value === null || value === undefined
		? ""
		: `${new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: maxFractionDigits }).format(value)}${NBSP}%`;

export const normalizeChange = (
	change: number | null | undefined,
): number | null => {
	if (change == null) return null;

	const roundedChange = roundNumber(change);
	return Math.abs(roundedChange) <= 0.01 ? 0 : roundedChange;
};

export const formatRate = (rate: number, fractionDigits = 2): string =>
	new Intl.NumberFormat("cs-CZ", {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(rate);
